<!--我的学习左侧导航-->
<template>
  <nav class="nav">
    <router-link class="link" to="/account/personal/schedule">
      <img class="img" src="./schedule.png" alt="schedule" width="24" height="24">
      <span class="text">课程日历表</span>
      <span class="arrow"></span>
    </router-link>
    <router-link class="link" :class="{'active':nowLink==='lesson'}" to="/account/personal/lesson">
      <img class="img" src="./course.png" alt="course" width="24" height="24">
      <span class="text">我的课程</span>
      <span class="arrow"></span>
    </router-link>
    <router-link class="link" to="/account/personal/work">
      <img class="img" src="./work.png" alt="course" width="24" height="24">
      <span class="text">作业管理</span>
      <span class="arrow"></span>
    </router-link>
<!--    <router-link class="link" to="/account/personal/testlive">-->
<!--      <img class="img" src="./zhiboceshi.png" alt="course" width="24" height="24">-->
<!--      <span class="text">直播测试</span>-->
<!--      <span class="arrow"></span>-->
<!--    </router-link>-->
    <router-link class="link" to="/account/personal/testurl">
      <img class="img" src="./device.png" alt="course" width="24" height="24">
      <span class="text">设备测试</span>
      <span class="arrow"></span>
    </router-link>
  </nav>
</template>

<script type="text/ecmascript-6">
  export default {
    props: {
      nowLink: {
        type: String,
        default: ''
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .nav
    float: left
    margin-right: 10px
    width: 250px
    height: 1047px
    background: #444;
    .link
      float: left;
      width: 100%
      height: 72px
      line-height: 50px;
      color: #fff;
      cursor: pointer
      &.active{
        color: #ffffff
        background: #ff6700
      }
      .img {
        float: left;
        margin: 24px 20px 0;
      }
      .text {
        font-size: 16px;
        color: #ffffff;
        line-height: 72px;
      }
      .arrow {
        float: right;
        margin: 30px 20px 0 0
        width: 8px
        height: 13px
        background: url('./arrow.png') no-repeat center / 8px 13px
      }
    .router-link-active
      color: #ffffff
      background: #ff6700
</style>



// WEBPACK FOOTER //
// src/components/mystudynav/MyStudyNav.vue